import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ErrorMessage = ({ 
  message = "Something went wrong. Please try again.", 
  onRetry,
  title = "Oops!" 
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // Check if this is a subscription-related message
  const isSubscriptionMessage = message.toLowerCase().includes('subscription');
  
  return (
    <div className="w-full">
      <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl border border-orange-200 p-8 text-center shadow-lg">
        <div className="space-y-6">
          {/* Icon */}
          <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto shadow-lg">
            {isSubscriptionMessage ? (
              <span className="text-3xl">🚀</span>
            ) : (
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            )}
          </div>
          
          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900">
            {isSubscriptionMessage ? t("messages.readyToGetStarted") : (title === "Oops!" ? t("messages.oops") : title)}
          </h2>
          
          {/* Message */}
          <p className="text-gray-600 text-center max-w-md">
            {isSubscriptionMessage 
              ? t("messages.chooseSubscriptionPlan")
              : (message === "Something went wrong. Please try again." ? t("messages.somethingWentWrongPleaseTryAgain") : message)
            }
          </p>
          
          {/* Action Buttons */}
          <div className="space-y-4">
            {isSubscriptionMessage ? (
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={() => navigate('/organization/subscription/packages')}
                  className="px-8 py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 hover:from-orange-600 hover:to-red-600"
                >
                  🎯 View Subscription Packages
                </button>
                {onRetry && (
                  <button
                    onClick={onRetry}
                    className="px-6 py-3 bg-white text-orange-600 border-2 border-orange-500 rounded-xl font-semibold transition-all duration-300 hover:bg-orange-50 hover:border-orange-600"
                  >
                    🔄 Try Again
                  </button>
                )}
              </div>
            ) : (
              onRetry && (
                <button
                  onClick={onRetry}
                  className="px-8 py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 hover:from-orange-600 hover:to-red-600"
                >
                  Try Again
                </button>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage; 